import Vue from "vue";
Vue.component("author-auto-complete-vue", {
  mounted() {
    const ul = document.getElementById("authors-list");
    const liCount = ul.getElementsByTagName("li").length;
    const wrapper = document.querySelector(".author-auto-complete-wrapper");

    if (liCount > 8) {
      ul.style.height = "30rem";
    }
    else if (liCount === 0) {
      wrapper.style.border = 'none';
    }
  }
});
